
import { ZPLJson } from "components/src/modules/labeler/models";
import { getCommodityGroupNameFormatted, getCommodityGroupNumberFormatted, getGrossPriceFormatted, getLiterTax, getLiterTaxFormatted, getProductNameForLabelFormatted, getProductPriceByPriceGroup, getProductPriceFormatted, getRawProductPrice, getSalesTax, getSalesTaxFormatted } from "../../products/data/helpers";


interface Fields {
    productName: string,
    productLookupCode: string,
    productWeight: string,
    weightProductLookupCode: string,
    productPrice: string,
    commodityGroupNumber: string,
    commodityGroupName: string,
    number: string,
    [key: string]: string,
    productPriceByPriceGroup?:any;
}

export const FIELDS: Fields = {
    productName: "%PRODUCTNAME%",
    productLookupCode: "%PRODUCTLOOKUPCODE%",
    productWeight: "%PRODUCTWEIGHT%",
    weightProductLookupCode: "%WEIGHTPRODUCTLOOKUPCODE%",
    productPrice: "%PRODUCTREGULARPRICE%",
    commodityGroupNumber: "%COMMODITYGROUPNUMBER%",
    commodityGroupName: "%COMMODITYGROUPNAME%",
    number: "%PRODUCTNUMBER%",
    productPriceByPriceGroup :'%PRODUCTPRICEBYPRICEGROUP%',
    productLiterTax :'%PRODUCTLITERTAX%',
    productSalesTax :'%PRODUCTSALESTAX%',
    productGrossPrice :'%PRODUCTGROSSPRICE%'
};


export interface FieldValues {
    productName?: string,
    productLookupCode?: string,
    productWeight?: number,
    weightProductLookupCode?: string,
    productPrice?: string,
    commodityGroupNumber?: string,
    commodityGroupName?: string,
    number?: string,
    productPriceByPriceGroup?: any,
    productLiterTax?: any,
    productSalesTax?: any,
    productGrossPrice?: any,
    [key: string]: string | number | undefined;
}

export interface GenerateZPLParams {
    template: any,
    product: any,
    scanCode: string,
    isAutoAdjustEnabled: boolean,
    currentPrintWidth: any,
    isMultiPrintEnabled: boolean,
    printQuantity: any,
    literTaxUUID: any,
    networkSettings?: {
      ip: string,
      port: string
    },
    /** When true, force Zebra ^BC interpretation line off (N) for promo/combo barcodes. */
    hideBarcodeInterpretationLine?: boolean,
}

export class ZPLUtil {
    constructor() { }

    public static convertJSONToZPL(data: ZPLJson) {
        let scriptBody = '';
        let startScript = "^XA" + "\n";
        let endScript = "^XZ";
        let graphicBox = "^FX" + "," + data.labelSize.width + ","
            + data.labelSize.height + "\n";
        for (let lfield of data.labelFields) {
            let fieldName = '';
            if (lfield.dataSource === "Data") {
                fieldName = "^FD" + "%" + lfield.name + "%" + "^FS" + "\n\n";
            } else if (lfield.dataSource === 'QRCodeData') {
                fieldName = "^FDQA," + lfield.name + "^FS" + "\n\n";
            } else if (lfield.dataSource === 'Static') {
                fieldName = "^FD" + lfield.staticText + "^FS" + "\n\n";
            } else if (lfield.dataSource === 'Literal') {
                fieldName = lfield.staticText + "\n\n";
            }
            let multiline = '';
            if (lfield.multiline) {
                multiline = "^FB" + lfield.multiline.width + "," + lfield.multiline.lines
                    + "," + lfield.multiline.spaceBetweenLines + "," + lfield.multiline.textJustification +
                    "," + lfield.multiline.hangingIndent + "\n";
            }
            let barcodeData = '';
            if (lfield.barcodeData) {
                barcodeData = "^BC" + lfield.barcodeData.orientation + "," +
                    lfield.barcodeData.height + "," + lfield.barcodeData.interpretationLine + "," +
                    lfield.barcodeData.interpretationLineAboveCode + "," + lfield.barcodeData.uccCheck + "," + lfield.barcodeData.mode + "\n";
            }
            let qrCodeData = '';
            if (lfield.qrCodeData) {
                qrCodeData = "^BQ" + lfield.qrCodeData.orientation + "," +
                    lfield.qrCodeData.model + "," + lfield.qrCodeData.magnification + "\n";
            }
            let position = '';
            if (lfield.position.textJustification != null) {
                position = "^FO" + lfield.position.left + "," + lfield.position.top +
                    "," + lfield.position.textJustification + "\n";
            } else if (lfield.position.top != null) {
                position = "^FO" + lfield.position.left + "," + lfield.position.top +
                    "\n";
            }
            let font = '';
            if (lfield.font != null) {
                if (lfield.font.default && lfield.font.default === true) {
                    font = "^A0" + lfield.font.orientation +
                        "," + lfield.font.height + "," + lfield.font.width + "\n";
                }else{
                font = "^A@" + lfield.font.orientation +
                    "," + lfield.font.height + "," + lfield.font.width + "," + lfield.font.driveLocation
                    + lfield.font.name + "." + lfield.font.extension + "\n";
                }
                
            }
            scriptBody = scriptBody + position + font + multiline + barcodeData + qrCodeData + fieldName;
        }
        const ZPL_FORMAT = startScript + scriptBody + endScript + "\n" + graphicBox;
        console.log(ZPL_FORMAT);
        return ZPL_FORMAT;
    }

    public static fillInfoInZPL(zpl: string, values: FieldValues, removeSign:boolean) {
        for (let f of Object.keys(FIELDS)) {
            // console.log(f);
            // console.log(values[f]);
            console.log("removeSign",removeSign)
            if (f === 'number') {
                // product number should not exceed 10 digits,
                if (String(values[f]).length > 10) {
                    const productNumber = String(values[f]).slice(0, 12);
                    zpl = zpl.replace(FIELDS[f], productNumber);
                } else {
                    zpl = zpl.replace(FIELDS[f], String(values[f]));
                }
            } else if (f === 'productPriceByPriceGroup') {
                let count = 0
                for (let p in values['productPriceByPriceGroup']){
                    let obj = values['productPriceByPriceGroup'][p]
                    let val = obj ? obj.replace('$', '') : '';
                    const priceString = parseFloat(val);
                    const price = Number(priceString).toFixed(2);
                    zpl = zpl.replace(FIELDS[f],  removeSign ? String(price) : `$${String(price)}`);    
                }
            } else {
                zpl = zpl.replace(FIELDS[f], String(values[f]));
            }
        }
        console.log(zpl);
        return zpl;
    }

    public static generateZPL(params: GenerateZPLParams) {
        const selTemp = params.template;
        if (selTemp) {
          const product = params.product;
          if (product.name.length > 0) {
            const zpl = ZPLUtil.convertJSONToZPL(selTemp.content);
            const productRawPrice = getRawProductPrice(product, params.scanCode);
            const productPrice = getProductPriceFormatted(product, params.scanCode, selTemp);
            const productName = getProductNameForLabelFormatted(product);
            const lt = getLiterTax(product, params.literTaxUUID);
            console.log("litertax", lt)
            const {taxAmount: literTaxAmount, literTaxRate} = lt;
            const productliterTax = getLiterTaxFormatted(literTaxAmount, literTaxRate, selTemp)
            const st = getSalesTax(product, productRawPrice);
            console.log("salestax", st)
            const {taxAmount: salesTaxAmount, salesTaxRate} = st;
            const productSalesTax = getSalesTaxFormatted(salesTaxAmount, salesTaxRate, selTemp);
            const productGrossPrice = productRawPrice + literTaxAmount + salesTaxAmount;
    
            const productGrossPriceFormatted = getGrossPriceFormatted(productGrossPrice, selTemp);
            
            let values: FieldValues = {
              productName: productName,
              productPrice: productPrice,
              productLookupCode: params.scanCode,
              productLiterTax: productliterTax,
              productSalesTax: productSalesTax,
              productGrossPrice: productGrossPriceFormatted,
            };
            let pg = selTemp.content.labelFields && selTemp.content.labelFields.find(l=>l.name ==='PRODUCTPRICEBYPRICEGROUP')
            if(pg != null){
                const noCurrency = selTemp.content.labelFields.find(lf=>lf.noCurrency && lf.noCurrency === true)
                let removeSign = false
                if (noCurrency != undefined){
                    removeSign = true
                }
                const productPriceGroup = getProductPriceByPriceGroup(product, params.scanCode, removeSign);
                values['productPriceByPriceGroup'] = productPriceGroup
            }
            if (product.commodityGroup) {
              if (product.commodityGroup.number) {
                values.commodityGroupNumber = getCommodityGroupNumberFormatted(product, selTemp);
              }
              if (product.commodityGroup.name) {
                values.commodityGroupName = getCommodityGroupNameFormatted(product, selTemp);
              }
            }
            const noCurrency = selTemp.content.labelFields.find(lf=>lf.noCurrency && lf.noCurrency === true)
            let removeSign = false
            if (noCurrency != undefined){
              removeSign = true
            }
            
            const filledInZpl = ZPLUtil.fillInfoInZPL(zpl, values, removeSign);
            let labelZPL = String(filledInZpl);
    
            if (params.isAutoAdjustEnabled) {
              const currentPrintWidth = Number(params.currentPrintWidth);
              if (currentPrintWidth && currentPrintWidth > 0) {
                // (required-reported)/2
                // 406-609/2 = -101.5 shifts to the right
                const dpi = 203;
                let offset = 0;
                const labelSizeString = filledInZpl.split('^FX,')[1];
                if (labelSizeString) {
                  const labelWidthInInch = Number(labelSizeString.split(',')[0]);
                  if (labelWidthInInch) {
                    switch (labelWidthInInch) {
                      case 1:
                        offset = Math.floor((1 * dpi - currentPrintWidth) / 2); // if 1inch label
                        break;
                      case 2:
                        offset = Math.floor((2 * dpi - currentPrintWidth) / 2); // if 2inch label
                        break;
                      case 3:
                        offset = Math.floor((3 * dpi - currentPrintWidth) / 2); // if 3inch label
                        break;
                      case 4:
                        offset = Math.floor((4 * dpi - currentPrintWidth) / 2); // if 4inch label
                        break;
                    }
                    // console.log('offset', offset);
                    const labelString = filledInZpl.split('^XA')[1];
                    const newZpl = '^XA' + '\n' + '^LS ' + offset + labelString;
                    // console.log('zpl with offset', newZpl);
                    labelZPL = newZpl;
                  }
                }
              }
            }
            if (+params.printQuantity > 1 && params.isMultiPrintEnabled === true) {
                // console.log(filledInZpl.split('\n^XZ'));
                const labelString = filledInZpl.split('\n^XZ');
                const newZpl =
                  labelString[0] +
                  '^PQ' +
                  params.printQuantity +
                  ',' +
                  '0,N,Y' +
                  '\n^XZ' +
                  labelString[1];
                labelZPL = newZpl;
            }
            if (params.hideBarcodeInterpretationLine) {
                // ^BCo,h,f,g,e,m — force f (print interpretation line) to N
                labelZPL = labelZPL.replace(/\^BC([A-Z]?),(\d+),Y,/g, '^BC$1,$2,N,');
            }
            return labelZPL
    
          } else {
            throw new Error("Product name is blank")
          }
        } else {
          throw new Error("No template selected")
        }
    }

    
}


